export default __webpack_public_path__ + "static/media/221091_info3.8a385874.pdf";